module.exports = __webpack_public_path__ + "img/he.a5923a81.svg";